import { render, staticRenderFns } from "./GoogleSignInButton.vue?vue&type=template&id=3c5f63c6"
import script from "./GoogleSignInButton.vue?vue&type=script&lang=js"
export * from "./GoogleSignInButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5f63c6')) {
      api.createRecord('3c5f63c6', component.options)
    } else {
      api.reload('3c5f63c6', component.options)
    }
    module.hot.accept("./GoogleSignInButton.vue?vue&type=template&id=3c5f63c6", function () {
      api.rerender('3c5f63c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GoogleSignInButton.vue"
export default component.exports